import React, { Component } from 'react';
import { Button, Modal, ModalBody } from 'reactstrap';

import './AreYouSure.scss';
import img from '../../assets/images/warning.png';

class AreYouSure extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false
        }

        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    render() {
        const closeBtn = <button className="close" onClick={this.toggle}>&times;</button>;

        return (
            <div style={{ display: 'inline-block' }}>
                <Button className={this.props.btnClass} onClick={this.toggle}><i className={this.props.btnIcon}></i> {this.props.buttonLabel}</Button>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <ModalBody className="text-center">
                        <div className="row">
                            <div className="col-12">{closeBtn}</div>
                        </div>
                        <img src={img} alt="warning" height="140" />
                        <h3 className="mb-3">Вы уверены?</h3>

                        <div className="row">
                            <div className="col-12">
                                <Button color="danger" className="mx-1" onClick={this.props.click}>Да</Button>
                                <Button color="secondary" className="mx-1" onClick={this.toggle}>Нет</Button>
                                <div className="text-danger">{this.props.errMessage}</div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

export default AreYouSure;